import { IUserFull } from 'models'

export const isAdmin = (profile: IUserFull | null) =>
  profile && profile.role === 'ADMIN'
export const isModer = (profile: IUserFull | null) =>
  profile && profile.role === 'MODER'
